import { render, staticRenderFns } from "./ListUserReadOnly.vue?vue&type=template&id=214a6b4e&scoped=true&"
import script from "./ListUserReadOnly.vue?vue&type=script&lang=js&"
export * from "./ListUserReadOnly.vue?vue&type=script&lang=js&"
import style0 from "./ListUserReadOnly.vue?vue&type=style&index=0&id=214a6b4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "214a6b4e",
  null
  
)

export default component.exports